import { SxProps } from '@mui/material';
import {black1, grey10} from "app/components/ThemeProvider/colors";

export const inputsBox: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#ffffff',
  width: '100%',
  borderRadius: '8px',
  boxShadow: '2px 2px 32px rgba(0, 0, 0, 0.06)',
  padding: '32px',
  gap: '32px',
};

export const additionsBox: SxProps = { mt: '28px', display: 'flex', flexDirection: 'column', gap: '12px' };
export const detailsInfoDesc: SxProps = { fontSize: '17px', color: 'rgba(20, 25, 31, 0.60)', lineHeight: '1' };
export const fileBox: SxProps = {
  width: '75%',
  background: grey10,
  borderRadius: '8px',
  display: 'flex',
  p: '12px 16px',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const watchBtn = {
  background: '#EAEAEA',
  height: '36px',
  padding: '8px 16px',
  borderRadius: '6px',
  color: black1,
  textDecoration: 'none',
  lineHeight: 1,
  fontWeight: 600,
  fontFamily: 'Yelo',
};
export const sendBtn: SxProps = {
  backgroundColor: 'rgba(0, 119, 214, 1)',
  height: '41px',
  '&:hover': {
    backgroundColor: 'rgba(0, 102, 185, 1)',
  },
  fontSize: '13px',
  color: 'white',
  lineHeight: '1',
  fontWeight: 600,
  display: 'flex',
  gap: '8px',
  justifyContent: 'center',
  alignItems: 'center',
  p: '12px 16px',
  borderRadius: '6px',

  '& .MuiSvgIcon-root': {
    width: '16px',
    height: '16px',
  },
};

export const detailsBox: SxProps = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '36px',
  height: '36px',
  borderRadius: '8px',
  cursor: 'pointer',
};
